import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP4UnderUtilizedOvw202510: FaireAdPerformancePeriodEntity = {
  token: "perf_p4_under_utilized_ovw_202510",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2025-10-01",
  endDate: "2025-10-31",
  impressions: 28891,
  clicks: 489,
  adsSpendDollars: 1776,
  budgetDollars: 15000,
  salesDollars: 30654,
  bestEstimateRoas: 17.26,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.12,
  newCustomersAcquired: 17,
  reorderConversions: 15,
  dataAvailableAtDate: "2025-11-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
